import React, { useState } from 'react';
import { Autocomplete, Grid, TextareaAutosize, TextField } from '@mui/material';
import { BANKS, CLIENT_TYPES, CREDIT_OPTIONS, STATES } from '../utils/lists';

export const GridFields = ({
	formik,
	fields = [],
	xs = 3,
	setAllowNextStep = null,
}) => {
	// Autocomplete States
	const [focusedStates, setFocusedStates] = useState(false);

	const handleFocusState = () => {
		setFocusedStates(true);
	};

	const handleBlurState = (list, name) => {
		setFocusedStates(false);
		const selectedOption = formik.values[name];
		setAllowNextStep(list.includes(selectedOption));
	};

	// Formik values
	const { setFieldValue, getFieldProps, touched, errors } = formik;
	return (
		<Grid container spacing={2} className='mt-3'>
			{fields.map(({ name, label, text = null, maxLength = 255 }) => {
				if (name === 'state') {
					return (
						<Grid item xs={xs} key={name}>
							<Autocomplete
								required
								fullWidth
								value={formik.values[name]}
								onChange={(_, value) => {
									setFieldValue(name, value);
								}}
								options={STATES}
								getOptionLabel={(option) => option}
								getOptionDisabled={(option) =>
									!STATES.includes(option)
								}
								onBlur={() => handleBlurState(STATES, name)}
								onFocus={handleFocusState}
								renderInput={(params) => (
									<TextField
										required
										margin='normal'
										{...params}
										{...getFieldProps(name)}
										label={label}
										error={
											focusedStates &&
											Boolean(
												touched[name] && errors[name]
											)
										}
										helperText={
											focusedStates &&
											touched[name] &&
											errors[name]
										}
									/>
								)}
							/>
						</Grid>
					);
				} else if (
					name === 'bank' ||
					name === 'bank_you_are_depositing_to'
				) {
					return (
						<Grid item xs={xs} key={name}>
							<Autocomplete
								required
								fullWidth
								value={formik.values[name]}
								onChange={(_, value) => {
									setFieldValue(name, value);
								}}
								options={BANKS}
								onBlur={() => handleBlurState(BANKS, name)}
								renderInput={(params) => (
									<TextField
										required
										margin='normal'
										{...params}
										{...getFieldProps(name)}
										label={label}
										error={Boolean(
											touched[name] && errors[name]
										)}
										helperText={
											touched[name] && errors[name]
										}
									/>
								)}
							/>
						</Grid>
					);
				} else if (name === 'credit') {
					return (
						<Grid item xs={xs} key={name}>
							<Autocomplete
								required
								fullWidth
								value={formik.values[name]}
								onChange={(_, value) => {
									setFieldValue(name, value);
								}}
								options={CREDIT_OPTIONS}
								onBlur={() =>
									handleBlurState(CREDIT_OPTIONS, name)
								}
								renderInput={(params) => (
									<TextField
										required
										margin='normal'
										{...params}
										{...getFieldProps(name)}
										label={label}
										error={Boolean(
											touched[name] && errors[name]
										)}
										helperText={
											touched[name] && errors[name]
										}
									/>
								)}
							/>
						</Grid>
					);
				} else if (name === 'type') {
					return (
						<Grid item xs={xs} key={name}>
							<Autocomplete
								required
								fullWidth
								value={formik.values[name]}
								onChange={(_, value) => {
									setFieldValue(name, value);
								}}
								options={CLIENT_TYPES.map(clitype => clitype.label)}
								onBlur={() =>
									handleBlurState(CLIENT_TYPES.map(clitype => clitype.label), name)
								}
								renderInput={(params) => (
									<TextField
										required
										margin='normal'
										{...params}
										{...getFieldProps(name)}
										label={label}
										error={Boolean(
											touched[name] && errors[name]
										)}
										helperText={
											touched[name] && errors[name]
										}
									/>
								)}
							/>
						</Grid>
					);
				} else if (name === 'additional_info') {
					return (
						<Grid item xs={12} key={name}>
							<TextareaAutosize
								aria-label='minimum height'
								minRows={20}
								variant='standard'
								{...getFieldProps(name)}
								label={label}
								placeholder='Escriba a detalle información adicional sobre su empresa.'
								style={{
									width: '100%',
									borderRadius: '3px',
									height: '150px',
									fontSize: '17px',
									resize: 'none',
									padding: '10px',
									marginTop: 10,
								}}
							/>
						</Grid>
					);
				} else {
					return (
						<Grid item xs={xs} key={name}>
							<TextField
								margin='normal'
								fullWidth
								type={name.includes('phone') ? 'tel' : 'text'}
								{...getFieldProps(name)}
								label={label}
								error={Boolean(touched[name] && errors[name])}
								helperText={
									(touched[name] && errors[name]) || text
								}
								inputProps={{ maxLength: maxLength }}
							/>
						</Grid>
					);
				}
			})}
		</Grid>
	);
};
